import React from 'react';
import Chip from 'src/shared/components/chip/Chip';
import { FeatureType } from 'src/shared/types';
import { getFeaturesDisplayText, isBasicProject } from 'src/shared/utils/featureHelpers';
import { MergedProjectRow } from '../../../../mergeProjectsWithDefinitions';

const NOT_SET = '—';

/**
 * What a project can do, as one searchable, sortable string — so the table sorts and filters on
 * the same text the reader sees. A project without a definition has not been told what it can do
 * yet, which is different from having been told "nothing".
 */
export const featuresSummary = (row: MergedProjectRow): string => {
    if (!row.hasDefinition) {
        return '';
    }

    const features = (row.definition?.features ?? []) as FeatureType[];

    return isBasicProject(features) ? 'Starter' : getFeaturesDisplayText(features);
};

type FeatureChipsProps = {
    /** The output of `featuresSummary` — a comma-separated list, or empty for nothing known. */
    summary: string;
};

const FeatureChips = ({ summary }: FeatureChipsProps) => {
    if (!summary) {
        return <span>{NOT_SET}</span>;
    }

    return (
        <span className='flex flex-wrap items-center gap-1'>
            {/* Recessive, so a dense row reads as data rather than as a row of buttons. */}
            {summary.split(', ').map(feature => (
                <Chip
                    key={feature}
                    label={feature}
                    backgroundColor='rgb(230, 230, 230)'
                    labelColor='rgb(33, 33, 33)'
                    className='!px-2 !py-0.5 text-sm'
                />
            ))}
        </span>
    );
};

export default FeatureChips;
